import { render, staticRenderFns } from "./CategoryEditModal.vue?vue&type=template&id=37165d14&scoped=true"
import script from "./CategoryEditModal.vue?vue&type=script&lang=js"
export * from "./CategoryEditModal.vue?vue&type=script&lang=js"
import style0 from "./CategoryEditModal.vue?vue&type=style&index=0&id=37165d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37165d14",
  null
  
)

export default component.exports